import React, { useState } from 'react';
import { personalInfoType } from '../../../../common/interfaces/myProfile/personalDetails/personalInfo';
import { useAppSelector } from '../../../../infra/hooks';
import DTOPersonalInfo from './DTOPersonalInfo';
import PersonalInfoPresenter from './PersonalInfoPresenter';
import { useTranslation } from 'react-i18next';

function personalInfoController() {
  const { t } = useTranslation();

  const [personalInfo, setPersonalInfo] = useState<personalInfoType>({
    firstName: '',
    lastName: '',
    DOB: new Date(),
    gender: '',
    martialStatus: '',
    country: '',
    email: '',
    phone: '',
    state: '',
    education: '',
    religious: '',
    nationalityId: 0,
    nationalityName: '',
  });

  function callBackFunc(data: personalInfoType) {
    setPersonalInfo(data);
  }
  const hr_view = useAppSelector((state) => state.isHRViewSlice.HRView);

  return (
    <>
      <DTOPersonalInfo setPersonalInfo={callBackFunc} />
      <PersonalInfoPresenter info={personalInfo} hr_view={hr_view} trans={t} />
    </>
  );
}

export default personalInfoController;
